<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-group">
	<!--		-->
	<!-- Info	-->
	<!--		-->
	<div class="main-group-item">
		<div class="main-group-item-center">
			<label class="main-group-title">Print Visitor Report</label>
		</div>
	</div>

	<!--			 -->
	<!-- Info (FYI)  -->
	<!--	 		 -->
	<!-- <div class="main-group-item" style="margin-top:0px">
		<div class="main-group-item-center-padding">
			<label class="main-group-info">Note: </label>
		</div>
	</div> -->

	<!--  	   	 	     -->
	<!-- Status Selector -->
	<!-- 			     -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Status</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="SelectedStatusSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedStatus"
					(ngModelChange)="onStatusChange($event)"
				>
					<option *ngFor="let r of lstStatusItems" [ngValue]="r">
						{{ r.VisitorLogStatusDesc }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!--  	   	 	     -->
	<!-- SortBy Selector -->
	<!-- 			     -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Sort By</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="SelectedSortBySelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedSortBy"
					(ngModelChange)="onSortByChange($event)"
				>
					<option *ngFor="let r of lstSortBy" [ngValue]="r">
						{{ r.SortByDesc }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="error-div" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div style="display: flex; flex-direction: column; align-items: center">
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<div style="display: flex; flex-direction: row; align-items: center">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onPrint()" [disabled]="isBusy == true">Print</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
		<!-- 				   -->
		<!-- Display When Busy -->
		<!-- 				   -->
		<div [style.display]="isBusy == true ? 'block' : 'none'" style="width: 20px">
			<img class="busy-img" src="assets/images/loading.gif" />
		</div>
	</div>
</div>
